import { motion } from "framer-motion";
import { Plane, PartyPopper, Briefcase, Users } from "lucide-react";
import { Reveal } from "./Reveal";
import { IMAGES } from "@/data/content";
import { useBooking } from "@/App";

const LIFE = [
  { icon: PartyPopper, label: "Festivals happen." },
  { icon: Plane, label: "Vacations happen." },
  { icon: Users, label: "Family functions happen." },
  { icon: Briefcase, label: "Work gets busy." },
];

export default function TravelCallout() {
  const { openBooking } = useBooking();
  return (
    <section className="py-24 sm:py-32 bg-ivory relative overflow-hidden" data-testid="travel-festival-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative rounded-[2.5rem] overflow-hidden bg-gradient-to-br from-forest via-botanical to-sage shadow-hover">
          <img
            src={IMAGES.thali}
            alt=""
            aria-hidden="true"
            className="absolute inset-0 w-full h-full object-cover opacity-[0.14]"
            loading="lazy"
          />
          <div className="relative px-8 sm:px-14 lg:px-20 py-16 sm:py-20 grid lg:grid-cols-2 gap-12 items-center">
            <Reveal>
              <p className="text-xs uppercase tracking-[0.25em] font-bold text-gold mb-4">
                The Aarogyam Bharat Difference
              </p>
              <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-ivory leading-[1.15] text-balance">
                Because Your Healthy Life Doesn't Stop When You Travel.
              </h2>
              <p className="mt-6 text-ivory/75 leading-relaxed max-w-lg">
                We don't want your health plan to collapse every time real life happens. Your coaching includes{" "}
                <span className="text-gold font-semibold">personalised travel & festival guidance</span> —
                practical strategies for eating out, social occasions and family functions.
              </p>
              <motion.button
                whileHover={{ scale: 1.04, y: -2 }}
                whileTap={{ scale: 0.97 }}
                onClick={openBooking}
                data-testid="travel-book-discovery-button"
                className="mt-8 inline-flex items-center gap-2 rounded-full bg-gold text-forest px-7 py-3.5 text-sm font-bold tracking-wide hover:bg-amber transition-colors"
              >
                START WITH A CONVERSATION
              </motion.button>
            </Reveal>
            <div className="grid grid-cols-2 gap-4">
              {LIFE.map((l, i) => {
                const Icon = l.icon;
                return (
                  <Reveal key={l.label} delay={i * 0.08}>
                    <motion.div
                      whileHover={{ y: -5, rotate: -1 }}
                      className="bg-ivory/10 backdrop-blur-md border border-ivory/15 rounded-2xl p-6 text-center"
                      data-testid={`travel-life-card-${i}`}
                    >
                      <Icon size={26} className="text-gold mx-auto mb-3" />
                      <p className="font-serif italic text-lg text-ivory">{l.label}</p>
                    </motion.div>
                  </Reveal>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
